import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const getStatic = params => new Promise(async (resolve, reject) => {

  let id = params.id ? sanitize(params.id) : null
  let keyword = params.keyword ? sanitize(params.keyword) : null
  let lang = params.lang ? sanitize(params.lang) : null
  let page = params.page ? sanitize(params.page) : null

  id = id ? encodeURIComponent(id) : null
  keyword = keyword ? encodeURIComponent(keyword) : null
  lang = lang ? encodeURIComponent(lang) : null
  page = page ? encodeURIComponent(page) : null

  let uri = '?options=json'
  uri = id &&
        id !== null &&
        id !== 'null' ? `${uri}&id=${id}` : uri
  uri = keyword &&
        keyword !== null &&
        keyword !== 'null' ? `${uri}&keyword=${keyword}` : uri
  uri = lang &&
        lang !== null &&
        lang !== 'null' ? `${uri}&lang=${lang}` : uri
  uri = page &&
        page !== null &&
        page !== 'null' ? `${uri}&page=${page}` : uri

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_GET_STATIC + uri)
    .then(response => {
      if (response.data.status === 'ok') resolve(response.data.answer)
    })
    .catch(error => reject(error))
})
